import { useEffect, useRef, useState } from 'react';
import { GroupsIcon } from '@ui/icons/material/Groups';
import { SchoolIcon } from '@ui/icons/material/School';
import { LibraryBooksIcon } from '@ui/icons/material/LibraryBooks';
import { WorkspacePremiumIcon } from '@ui/icons/material/WorkspacePremium';
import '../styles/staff-stats.css';

interface Stat {
  label: string;
  value: number;
  suffix: string;
  icon: React.ReactNode;
}

const stats: Stat[] = [
  { label: 'TOP #5 TRƯỜNG ĐẠI HỌC', value: 5, suffix: '', icon: '/images/ctump/sv5.png' },
  { label: 'SINH VIÊN CÓ VIỆC LÀM', value: 95, suffix: '%', icon: '/images/ctump/sv1.png' },
  { label: 'GIẢNG VIÊN', value: 543, suffix: '', icon: '/images/ctump/sv4.png' },
  { label: 'HỌC VIÊN, SINH VIÊN ĐANG HỌC', value: 14000, suffix: '', icon: '/images/ctump/sv2.png' },
  { label: 'HỌC VIÊN, SINH VIÊN ĐÃ TỐT NGHIỆP', value: 20000, suffix: '+', icon: '/images/ctump/sv3.png' },
];

export default function StaffStats() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [counters, setCounters] = useState<number[]>(stats.map(() => 0));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Start counter animation
          stats.forEach((stat, index) => {
            const duration = 2000;
            const steps = 60;
            const stepValue = stat.value / steps;
            let current = 0;

            const interval = setInterval(() => {
              current += stepValue;
              if (current >= stat.value) {
                setCounters((prev) => {
                  const newCounters = [...prev];
                  newCounters[index] = stat.value;
                  return newCounters;
                });
                clearInterval(interval);
              } else {
                setCounters((prev) => {
                  const newCounters = [...prev];
                  newCounters[index] = Math.floor(current);
                  return newCounters;
                });
              }
            }, duration / steps);

            return () => clearInterval(interval);
          });
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="staff-stats section" ref={sectionRef}>
      <div className="container" style={{maxWidth: '1400px'}}>
          <h2 className="section-title fade-up">VÌ SAO HƠN <b style={{color: "#c0392b"}}>34.000 SINH VIÊN</b> LỰA CHỌN <b style={{color: "#2980b9"}}>CTUMP</b> ?</h2>
        
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card fade-up">
              <div className="stat-icon">
                  <img src={stat.icon} alt={''}/>
              </div>
              <div className="stat-value">
                {counters[index]}{stat.suffix}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}